site.video = {
	player: null,
	players: null,
	loaded:false,
	init:function() {
		var $body = $('body'),
			players = site.video.getVideos();

		if (players.length == 0) return false;

		if(players && $('#hero .item').hasClass('vimeo')) {
			$.each(players, function(i,value){
				var iframe = $('iframe#'+value);
				iframe.attr('src',iframe.data('src'));
				site.video.player = new Vimeo.Player(iframe);

				site.video.player.on('timeupdate', function(data) {
					if (!site.video.loaded) {
						$('#hero .item').addClass('loaded');
						site.video.loaded = true;
					}
				});
			});



			if ($body.width() > 768 + 15) {
				$body.addClass('playing');
				$(window).scroll(function (event) {
					var scroll = $(window).scrollTop();
					if (scroll > $('#hero .item').height()) {
						if ($body.hasClass('playing')) {
							$body.removeClass('playing');
							$.each(site.video.players, function(i,value){
								site.video.player.pause();
							});
						}
					}
					else {
						if (!$body.hasClass('playing')) {
							$body.addClass('playing');
							site.video.player.play();
						}
					}
				});
			}
		}

		if ($('#hero .item').hasClass('videoTag')) {
			$('video').bind('loadeddata', function(e) {
				$('#hero .item').addClass('loaded');
			});
		}

		$('.sound').on('click touchStart', function(e) {
			e.preventDefault();
			muterVimeo(e);
		});

		$('.playPause').on('click', function(e) {
			e.preventDefault();
			if ($body.hasClass('playing')) {
				$.each(site.video.players, function(i,value){
					site.video.player.pause();
				});
				$body.removeClass('playing');
			}
			else {
				site.video.player.play();
				$body.addClass('playing');
			}
		});
	},

	getVideos: function() {
		site.video.players = [];
		$('.item.video').each(function(i, value) {
			var $this = $(this);
			site.video.players[i] = $this.find('iframe').attr('id');
		});
		return site.video.players;
	}
};
